const RECENTLY_VIEWED_STORAGE_KEY = "eira:recently-viewed-products";
export const RECENTLY_VIEWED_UPDATED_EVENT = "eira:recently-viewed-products-updated";
const MAX_RECENTLY_VIEWED_PRODUCTS = 6;

const storedProduct = (product) => ({
  id: product.id,
  slug: product.slug,
  name: product.name,
  brand: product.brand,
  images: Array.isArray(product.images) ? product.images.slice(0, 1) : [],
  price: product.price,
  mrp: product.mrp,
  stock: product.stock,
  variants: Array.isArray(product.variants)
    ? product.variants.map((variant) => ({
      label: variant.label,
      price: variant.price,
      mrp: variant.mrp,
      stock: variant.stock,
    }))
    : [],
  rating: product.rating,
  review_count: product.review_count,
  is_new: product.is_new,
  is_best_seller: product.is_best_seller,
  food_symbol: product.food_symbol,
});

export const getRecentlyViewedProducts = () => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY) || "[]");
    return Array.isArray(stored)
      ? stored
        .filter((product) => product && typeof product.id === "string")
        .slice(0, MAX_RECENTLY_VIEWED_PRODUCTS)
      : [];
  } catch {
    return [];
  }
};

export const recordRecentlyViewedProduct = (product) => {
  if (!product?.id) {
    return;
  }
  const nextProducts = [
    storedProduct(product),
    ...getRecentlyViewedProducts().filter((item) => item.id !== product.id),
  ].slice(0, MAX_RECENTLY_VIEWED_PRODUCTS);
  try {
    sessionStorage.setItem(RECENTLY_VIEWED_STORAGE_KEY, JSON.stringify(nextProducts));
    window.dispatchEvent(new Event(RECENTLY_VIEWED_UPDATED_EVENT));
  } catch {
    return;
  }
};